import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { CreateEventInput, CreateEventResponse } from './useCreateEventMutation'

export interface UpdateEventInput extends Partial<CreateEventInput> {
  id: string
  temp_file_ids?: string[]
}

const API_URL =
  import.meta.env.VITE_EPC_API_URL ?? import.meta.env.REACT_APP_API_URL ?? ''

export const useUpdateEventMutation = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation<CreateEventResponse, Error, UpdateEventInput>({
    mutationFn: async (eventData) => {
      const { id, ...updateData } = eventData
      if ('keywords' in updateData) {
        console.log('[Keywords] PUT /events/{id} request:', {
          eventId: id,
          keywords: updateData.keywords,
          keywordCount: updateData.keywords?.length || 0,
        })
      }
      const response = await fetchWithAuth(`${API_URL}/events/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      })
      if ('keywords' in response) {
        console.log('[Keywords] PUT /events/{id} response:', {
          eventId: id,
          keywords: response.keywords,
          keywordCount: response.keywords?.length || 0,
        })
      }
      return response
    },
    onSuccess: (_, variables) => {
      // Invalidate the specific event query to trigger a refetch
      queryClient.invalidateQueries({ queryKey: ['event', variables.id] })
      // Also invalidate the events list
      queryClient.invalidateQueries({ queryKey: ['events'] })
    },
  })
}
